import { render, staticRenderFns } from "./characterSys.vue?vue&type=template&id=6ce123c5&scoped=true&"
import script from "./characterSys.vue?vue&type=script&lang=js&"
export * from "./characterSys.vue?vue&type=script&lang=js&"
import style0 from "./characterSys.vue?vue&type=style&index=0&id=6ce123c5&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce123c5",
  null
  
)

export default component.exports